import React from "react";
// import { FidgetSpinner } from "react-loader-spinner";

import MappixLogo from "../../../assets/images/MappixLogo.png";
// import { Skeleton } from "react-skeleton-generator";

import "../../../assets/stlyes/LoadingSpinner.css";

const LoadingSpinner = () => {
  return (
    <>
      <div className="top-loading-bar">
        <div>
          {/* <div><FidgetSpinner backgroundColor="#f34970" ballColors={["#26c8b9", "#f4c900", "#aabb5d"]} /></div>
          <div className="two-nd-loader"><FidgetSpinner backgroundColor="#f34970" ballColors={["#26c8b9", "#f4c900", "#aabb5d"]} /></div> */}
          <h1 className="loading-text"><img src={MappixLogo} className="nav-logo" alt="Mappix" style={{ width:"101px",height:"47px" }} /></h1>
        </div>
      </div>
      {/* <Skeleton.SkeletonThemeProvider >
        // <Skeleton width="50px" height="50px" borderRadius="50%" />
        <Skeleton count={10} height="15px" spaceBetween="20px" borderRadius="20px" width="80%" />
      </Skeleton.SkeletonThemeProvider> */}
    </>
    // <div className="top-loading-bar">
    //   <div className="loading-text">
    //     <span className="loading-text-words">m</span>
    //     <span className="loading-text-words">a</span>
    //     <span className="loading-text-words">p</span>
    //     <span className="loading-text-words">p</span>
    //     <span className="loading-text-words">I</span>
    //     <span className="loading-text-words">x</span>
    //   </div>
    // </div>
  );
}

export { LoadingSpinner };